import { SVGProps } from 'react';

const IcUpload = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <path
        d='M10.7505 17V6.8125L7.50049 10.0625L5.75049 8.25L12.0005 2L18.2505 8.25L16.5005 10.0625L13.2505 6.8125V17H10.7505ZM4.50049 22C3.81299 22 3.22445 21.7552 2.73486 21.2656C2.24528 20.776 2.00049 20.1875 2.00049 19.5V15.75H4.50049V19.5H19.5005V15.75H22.0005V19.5C22.0005 20.1875 21.7557 20.776 21.2661 21.2656C20.7765 21.7552 20.188 22 19.5005 22H4.50049Z'
        fill={props.fill || '#1D2129'}
      />
    </svg>
  );
};

export default IcUpload;
